<template>
    <section class="c-search-page__form">
        <form @submit.prevent="updateSearchResults" class="c-search-form" method="get">
            <input :placeholder="search" class="c-search-input field" name="q"
                    type="text"
                    v-model="search" value=""/>
            <button class="c-search-submit c-btn"
                    type="submit"
                    value="Search"><i class="fal fa-search" aria-hidden="true"></i> Search
            </button>
        </form>
    </section>
</template>

<script>
    import 'lodash.debounce'
    import {EventBus} from "../event-bus";

    export default {
        name: "SearchForm",
        data() {
            return {
                search: '',
            }
        },
        mounted() {
            EventBus.$on('url-params-updated', this.existingSearch)
        },
        methods: {
            existingSearch(urlParams) {
                if (urlParams.hasOwnProperty('q')) {
                    if (this.search !== urlParams.q) {
                        this.search = urlParams.q

                        // Once DOM updated update the search result
                        this.$nextTick(this.updateSearchResults)
                    }
                }
            },
            updateSearchResults(e) {
                EventBus.$emit('update-url-params', {name: 'q', value: this.search, state: this.search.length > 0})
                EventBus.$emit('new-search')
            }
        }
    }
</script>

<style scoped>

</style>
